import { combineReducers } from 'redux';
import { createReduceObject as createReqStatusReduceObject } from '../../../../common/reducers/_requestStatus/reducer';
import { createReduceObject as createErrorsFormReduceObject } from '../../../../common/reducers/_formErrors/reducer';
import { createReduceObject as createFormReduceObject } from './reducer';
import { reducerRegistry } from '../../../../reducerRegistry';
import createSaga from './saga';

export function createCombineReducers(reducerName) {
  const combine = combineReducers({
    ...createReqStatusReduceObject(reducerName),
    ...createFormReduceObject(reducerName),
    ...createErrorsFormReduceObject(reducerName)
  });
  reducerRegistry.register(reducerName, combine, createSaga);
}

export function removeCombineReducers(reducerName) {
  reducerRegistry.remove(reducerName);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/payment/reducers/paymentForm/combine.js